<template>
  <v-dialog v-model="show" max-width="1200" persistent v-if="show">
    <v-card style="padding:15px;">
      <v-card-title> Cambio de dirección </v-card-title>
      <v-row>
        <v-col cols="12" xl="6">
          <v-text-field
            autocomplete="new"
            autofocus
            :error-messages="direccionErrors"
            @input="$v.objetoCambioDireccion.Direccion.$touch()"
            @blur="$v.objetoCambioDireccion.Direccion.$touch()"
            v-model="objetoCambioDireccion.Direccion[0].direccion"
            outlined
            label="Dirección"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xl="6">
          <v-text-field
            autocomplete="new"
            :error-messages="estadoErrors"
            @input="$v.objetoCambioDireccion.Direccion.$touch()"
            @blur="$v.objetoCambioDireccion.Direccion.$touch()"
            v-model="objetoCambioDireccion.Direccion[0].estado"
            outlined
            label="Estado"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xl="6">
          <v-text-field
            autocomplete="new"
            :error-messages="municipioErrors"
            @input="$v.objetoCambioDireccion.Direccion.$touch()"
            @blur="$v.objetoCambioDireccion.Direccion.$touch()"
            v-model="objetoCambioDireccion.Direccion[0].municipio"
            outlined
            label="Ciudad"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xl="6">
          <v-text-field
            autocomplete="new"
            :error-messages="cpErrors"
            @input="$v.objetoCambioDireccion.Direccion.$touch()"
            @blur="$v.objetoCambioDireccion.Direccion.$touch()"
            v-model="objetoCambioDireccion.Direccion[0].codigopostal"
            outlined
            label="Codigo postal"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xl="6">
          <!-- TODO  ojito aqui-->

          <v-text-field
            autocomplete="new"
            :error-messages="coloniaErrors"
            @input="$v.objetoCambioDireccion.Direccion.$touch()"
            @blur="$v.objetoCambioDireccion.Direccion.$touch()"
            v-model="objetoCambioDireccion.Direccion[0].colonia"
            outlined
            label="Colonia"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            autocomplete="new"
            :error-messages="paisErrors"
            @input="$v.objetoCambioDireccion.Direccion.$touch()"
            @blur="$v.objetoCambioDireccion.Direccion.$touch()"
            v-model="objetoCambioDireccion.Direccion[0].pais"
            outlined
            label="País"
          ></v-text-field>
        </v-col>
        <v-col v-if="!errorMostrador" cols="6">
          <v-text-field
            autocomplete="new"
            :error-messages="costoErrors"
            @input="$v.objetoCambioDireccion.Costo.$touch()"
            @blur="$v.objetoCambioDireccion.Costo.$touch()"
            @focus="$event.target.select()"
            v-model="objetoCambioDireccion.Costo"
            outlined
            label="Costo"
          ></v-text-field>
        </v-col>
        <v-col v-if="!errorMostrador" cols="6">
          <v-text-field
            autocomplete="new"
            :error-messages="pagoErrors"
            @input="$v.objetoCambioDireccion.Pago.$touch()"
            @blur="$v.objetoCambioDireccion.Pago.$touch()"
            @focus="$event.target.select()"
            v-model="objetoCambioDireccion.Pago"
            outlined
            label="Pago"
          ></v-text-field>
        </v-col>
        <v-col v-if="!errorMostrador" cols="12">
          <v-select
            v-model="objetoCambioDireccion.tipo_pago"
            :items="['Efectivo', 'Transferencia', 'Deposito']"
            label="Método de pago"
            outlined
          ></v-select>
        </v-col>
        <v-col cols="6">
          <v-switch
            inset
            label="Error ocasionado por mostrador"
            v-model="errorMostrador"
          ></v-switch>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" @click="$emit('cerrar-modal-cdir', 'cancela')" text
          >Cancelar</v-btn
        >
        <v-btn color="blue darken-1" @click="realizarCambioDireccion" text>Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { required, decimal, minValue, maxValue, requiredIf } from "vuelidate/lib/validators";
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
const direccionPaisRegex = /^([a-zA-ZÁÉÍÓÚáéíóúñÑäÄöÖüÜ ]{0,50})$/;
const direccionEstadoRegex = /^([a-zA-ZÁÉÍÓÚáéíóúñÑäÄöÖüÜ ]{1,40})$/;
const direccionMunicipioRegex = /^([a-zA-ZÁÉÍÓÚáéíóúñÑäÄöÖüÜ ]{1,80})$/;
const direccionCodigoPostalRegex = /^([0-9]{3,6})$/;
const direccionColoniaRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñ0-9 äÄöÖüÜ!@#$%^&*/|().,´"'_+]){1,50})$/;
const direccionDireccionRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñ0-9 äÄöÖüÜ!@#$%^&*/|().,´"'_+]){1,50})$/;

import { mapActions, mapState } from "vuex";
export default {
  validations: {
    objetoCambioDireccion: {
      Pago: {
        required: requiredIf(function(form) {
          return this.errorMostrador;
        }),
        decimal,
        valorMinimoPago(Pago) {
          if (!this.errorMostrador && parseFloat(Pago) < 0) {
            return false;
          } else {
            return true;
          }
        },
        pagoValido(Pago) {
          if (
            parseFloat(Pago) > parseFloat(this.objetoCambioDireccion.Costo) &&
            !this.errorMostrador
          ) {
            return false;
          } else {
            return true;
          }
        }
      },
      Costo: {
        required: requiredIf(function(form) {
          return this.errorMostrador;
        }),
        decimal,
        valorMinimoCosto(Costo) {
          if (!this.errorMostrador && parseFloat(Costo) < 1) {
            return false;
          } else {
            return true;
          }
        },
        costoValido(Costo) {
          if (
            parseFloat(Costo) < parseFloat(this.objetoCambioDireccion.Pago) &&
            !this.errorMostrador
          ) {
            return false;
          } else {
            return true;
          }
        }
      },
      Direccion: {
        $each: {
          direccion: {
            required,
            direccionValida(direccion) {
              return direccionDireccionRegex.test(direccion);
            }
          },
          estado: {
            required,
            estadoValida(estado) {
              return direccionEstadoRegex.test(estado);
            }
          },
          municipio: {
            required,
            municipioValida(municipio) {
              return direccionMunicipioRegex.test(municipio);
            }
          },
          codigopostal: {
            required,
            codigoPostalValida(codigopostal) {
              return direccionCodigoPostalRegex.test(codigopostal);
            }
          },
          colonia: {
            required,
            coloniaValida(colonia) {
              return direccionColoniaRegex.test(colonia);
            }
          },
          pais: {
            required,
            paisValida(pais) {
              return direccionPaisRegex.test(pais);
            }
          }
        }
      }
    }
  },
  data: () => ({
    errorMostrador: false,
    objetoCambioDireccion: {
      IdEnvio: "",
      idSucursal: 0,
      Direccion: [
        {
          pais: "",
          estado: "",
          municipio: "",
          codigopostal: "",
          colonia: "",
          direccion: ""
        }
      ],
      Costo: 0,
      Pago: 0,
      tipo_pago: "Efectivo"
    }
  }),
  computed: {
    ...mapState({
      logedInUserInfo: state => state.sesion.logedInUserInfo
    }),
    direccionErrors() {
      const errors = [];
      if (!this.$v.objetoCambioDireccion.Direccion.$each[0].direccion.$dirty) return errors;
      !this.$v.objetoCambioDireccion.Direccion.$each[0].direccion.required &&
        errors.push("El campo dirección es requerido.");
      !this.$v.objetoCambioDireccion.Direccion.$each[0].direccion.direccionValida &&
        errors.push("El campo dirección no es válido.");
      return errors;
    },
    estadoErrors() {
      const errors = [];
      if (!this.$v.objetoCambioDireccion.Direccion.$each[0].estado.$dirty) return errors;
      !this.$v.objetoCambioDireccion.Direccion.$each[0].estado.required &&
        errors.push("El campo estado es requerido.");
      !this.$v.objetoCambioDireccion.Direccion.$each[0].estado.estadoValida &&
        errors.push("El campo estado no es válido.");
      return errors;
    },
    municipioErrors() {
      const errors = [];
      if (!this.$v.objetoCambioDireccion.Direccion.$each[0].municipio.$dirty) return errors;
      !this.$v.objetoCambioDireccion.Direccion.$each[0].municipio.required &&
        errors.push("El campo ciudad es requerido.");
      !this.$v.objetoCambioDireccion.Direccion.$each[0].municipio.municipioValida &&
        errors.push("El campo ciudad no es válido.");
      return errors;
    },
    cpErrors() {
      const errors = [];
      if (!this.$v.objetoCambioDireccion.Direccion.$each[0].codigopostal.$dirty) return errors;
      !this.$v.objetoCambioDireccion.Direccion.$each[0].codigopostal.required &&
        errors.push("El campo código postal es requerido.");
      !this.$v.objetoCambioDireccion.Direccion.$each[0].codigopostal.codigoPostalValida &&
        errors.push("El campo código postal no es válido.");
      return errors;
    },
    coloniaErrors() {
      const errors = [];
      if (!this.$v.objetoCambioDireccion.Direccion.$each[0].colonia.$dirty) return errors;
      !this.$v.objetoCambioDireccion.Direccion.$each[0].colonia.required &&
        errors.push("El campo colonia postal es requerido.");
      !this.$v.objetoCambioDireccion.Direccion.$each[0].colonia.coloniaValida &&
        errors.push("El campo colonia postal no es válido.");
      return errors;
    },
    paisErrors() {
      const errors = [];
      if (!this.$v.objetoCambioDireccion.Direccion.$each[0].pais.$dirty) return errors;
      !this.$v.objetoCambioDireccion.Direccion.$each[0].pais.required &&
        errors.push("El campo país es requerido.");
      !this.$v.objetoCambioDireccion.Direccion.$each[0].pais.paisValida &&
        errors.push("El campo país no es válido.");
      return errors;
    },
    pagoErrors() {
      const errors = [];
      if (!this.$v.objetoCambioDireccion.Pago.$dirty) return errors;
      !this.$v.objetoCambioDireccion.Pago.required && errors.push("El campo pago es requerido.");
      !this.$v.objetoCambioDireccion.Pago.decimal &&
        errors.push("El campo pago debe ser númerico.");
      // !this.$v.objetoCambioDireccion.Pago.valorMinimoPago &&
      //   errors.push("El campo pago debe ser mayor o igual a 1.");
      !this.$v.objetoCambioDireccion.Pago.pagoValido &&
        errors.push("El campo pago debe ser menor o igual al costo");
      return errors;
    },
    costoErrors() {
      const errors = [];
      if (!this.$v.objetoCambioDireccion.Costo.$dirty) return errors;
      !this.$v.objetoCambioDireccion.Costo.required && errors.push("El campo costo es requerido.");
      !this.$v.objetoCambioDireccion.Costo.decimal &&
        errors.push("El campo costo debe ser númerico.");
      !this.$v.objetoCambioDireccion.Costo.valorMinimoCosto &&
        errors.push("El campo costo debe ser mayor o igual a 1.");
      !this.$v.objetoCambioDireccion.Pago.pagoValido &&
        errors.push("El campo costo debe ser mayor o igual al pago");
      return errors;
    }
  },
  mounted() {
    this.objetoCambioDireccion.Direccion[0].direccion = this.direccionPasada[
      this.direccionPasada.length - 1
    ].direccion;
    this.objetoCambioDireccion.Direccion[0].estado = this.direccionPasada[
      this.direccionPasada.length - 1
    ].estado;
    this.objetoCambioDireccion.Direccion[0].municipio = this.direccionPasada[
      this.direccionPasada.length - 1
    ].municipio;
    this.objetoCambioDireccion.Direccion[0].codigopostal = this.direccionPasada[
      this.direccionPasada.length - 1
    ].codigopostal;
    this.objetoCambioDireccion.Direccion[0].colonia = this.direccionPasada[
      this.direccionPasada.length - 1
    ].colonia;
    this.objetoCambioDireccion.Direccion[0].pais = this.direccionPasada[
      this.direccionPasada.length - 1
    ].pais;
    this.objetoCambioDireccion.idSucursal = this.logedInUserInfo.sucursal;
    this.objetoCambioDireccion.IdEnvio = this.idEnvio;
  },
  watch: {
    errorMostrador() {
      if (this.errorMostrador) {
        this.objetoCambioDireccion.Pago = 0;
        this.objetoCambioDireccion.Costo = 0;
        this.$v.$reset();
      }
    }
  },
  props: { show: Boolean, idEnvio: Number, direccionPasada: Array, nombreDecliente: String },
  methods: {
    ...mapActions("abonosEnvios", ["cambioDireccion","registraNombreAbonante"]),
    meMuestro(index) {
      if (this.codigosPostalesEncontrados[index].length > 1) {
        return true;
      }
      return false;
    },
    async realizarCambioDireccion() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        if (this.errorMostrador) {
          this.objetoCambioDireccion.ErrorMostrador = 1;
          delete this.objetoCambioDireccion.Costo;
          delete this.objetoCambioDireccion.Pago;
        }
        await this.registraNombreAbonante(this.nombreDecliente);
        const res = await this.cambioDireccion(this.objetoCambioDireccion);
        if (res[0]) {
          //TODO solo deberia recargar pagina si la insercion es exitosa
          this.$emit("cerrar-modal-cdir",'cambiodireccioncorrecto');
        }
      }
    }
  }
};
</script>
<style lang="css"></style>
